export default {
    layout: {
        zh: '简体中文',
        zhTw: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
        copyAddress: '複製地址',
        switchWallet: '切換錢包',
        disconnect: '斷開連接',
        copied: '複製成功',
        failed:'failed',
        success:'success',
    },
    node: {
        progress: '交易進行中',
        executionSuccessful: '執行成功',
        at: '在',
        view: '查看',
    },
    menu: {
        home: '首頁',
        exchange: '兌換',
        mining: '挖礦',
        assets: '資產',
        earnings: '收益',
        me: '我的',
        notice: '公告',
    },
    exchange: {
        title: '兌換',
        send: '發送',
        receive: '接收',
        obtain: '獲得',
        consume: '消耗',
        balance: '資產餘額',
        max: '最大',
        currentPrice: '當前價格',
        submit: '兌換',
        records: '兌換記錄',
        price: '價格',
        success: '成功',
        fail: '失敗',
    },
    home: {
        brand: 'OnOx',
        slogan: '連接全球 賦能未來',
        sloganDesc: '去中心化·更開放·更高效',
        yield: '收益率',
        notice: '公告1，ABC挖礦上線運營',
        todayOutput: '今日礦池產出',
        networkHashrate: '全網有效算力',
        price: '當前幣價',
        burned: '總銷毀量',
        aboutTitle: '關於ONOX算力挖礦',
        aboutDesc: 'ONOX連接真實算力節點，將設備產出、收益結算與資產管理整合於一個可信賴的移動端賬戶。',
        featureHashrate: '真實算力接入',
        featureHashrateDesc: '節點狀態透明，算力數據實時更新',
        featureDaily: '每日收益結算',
        featureDailyDesc: '按有效算力計費，收益記錄清晰可追溯',
        featureSecurity: '數字資產安全',
        featureSecurityDesc: '錢包地址綁定，提現操作多重驗證',
        bindTitle: '綁定邀請地址',
        bindConfirm: '確認綁定',
        bindPlaceholder: '0x000000000000000000000000000000',
        h11:'火牛憲章',
        h12:'DolphFi生態 首發DAPP',
        h21:'火牛憲章',
        h22:'燃動未來',
        h31:'OnOx',
        h32:'焰領牛勢',
    },
    mining: {
        title: '燃燒挖礦',
        subtitle: '激活算力 共享生態收益',
        totalT: '總算力 (T)',
        shareT: '分享算力',
        teamT: '團隊算力',
        burnT: '燃燒算力',
        validBurnT: '有效燃燒算力',
        renew: '續約',
        amountPlaceholder: '請輸入燃燒算力數值',
        token: '燃燒幣種',
        rate: '實時換算',
        balance: '錢包餘額',
        submit: '參與燃燒挖礦',
        hint: '實際可獲得',
        burnLog: '燃燒記錄',
        shareLog: '分享算力',
        renewLog: '續約記錄',
        success: '成功',
        fail: '失敗',
        qty: '數量',
        hashrateT: '算力 (T)',
        renewHashrate: '續約算力',
        renewFee: '續約費用',
        renewDate: '算力日期',
        renewConvert: '折算數量',
        renewNote: '說明',
        renewNoteText: '請在2026.10.1前續約，逾期將無法獲得挖礦收益。',
        renewConfirm: '確認續約',
        ext1:'獎勵算力',
        ext2:'挖礦收益',
        ext3:'續約金額',
        rechargeTip: '首次參與？請先儲值 DOL 或 USDT',
        goRecharge: '去充值',
        renewdo:'已續約',
    },
    earnings: {
        balance: '資產餘額',
        recharge: '去充值',
        withdraw: '去提現',
        totalWithdraw: '累計提幣',
        totalIncome: '總收益',
        mineIncome: '挖礦收益',
        referral: '推薦獎勵',
        incomeLog: '收益記錄',
        rechargeLog: '充值記錄',
        withdrawLog: '提現記錄',
        qty: '數量',
        success: '成功',
        pending: '待轉賬',
        fail: '失敗',
         1: '成功',
        0: '待轉賬',
        2: '失敗',
        rechargeQty: '充值數量',
        withdrawQty: '提現數量',
        receiveQty: '到賬數量',
        rechargeTitle: '充值',
        withdrawTitle: '提現',
        rechargeMin: '不能小於10',
        minAmount: '不能小於100',
        toAccount: '提現到賬',
        fee: '手續費',
        rechargeAddress: '充值地址',
        address: '提現地址',
        confirmRecharge: '確認充值',
        confirmWithdraw: '確認提幣',
        recharpcho:'请输入充值金额',
        l1:'挖礦收益',
        l2:'直推獎勵',
        l3:'間推獎勵'
    },
    me: {
        inviteLink: '我的邀請鏈接',
        upline: '上級地址',
        inviteCount: '邀請人數',
        teamCount: '團隊人數',
        bigArea: '大區算力 (T)',
        smallArea: '小區總燃燒算力 (T)',
        team: '團隊成員',
        direct: '直推',
        indirect: '間推',
        umbrella: '傘下',
        burnT: '燃燒算力 (T)',
        personT: '個人算力 (T)',
        teamBurn: '團隊燃燒算力 (T)',
        teamHash: '團隊算力 (T)',
        remark: '備註',
        setRemark: '設置備註',
        remarkPlaceholder: '請輸入備註',
        confirm: '確認',
    },
    notice: {
        title: '公告詳情',
        headline: '大標題大標題大標題大標題',
        date: '2024-12-22',
        body: '尊敬的用戶：\n\n您好！\n\nXXXApp將於2024年11月26日晚上8點正式上線，同時最低認購基礎也將同步更新，其他不變，具體認購基礎以App顯示為準。',
    },
};
